var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSoldPrice(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1159_4915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 30L19 30",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 14L16 8.5",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5 18L19.8667 12.836",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.41421,
    y: 16.1367,
    width: 4.66411,
    height: 10.2175,
    rx: 1,
    transform: "rotate(-45 5.41421 16.1367)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.8387,
    y: 6.71216,
    width: 4.66411,
    height: 10.2175,
    rx: 1,
    transform: "rotate(-45 14.8387 6.71216)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.8206,
    y: 15.9062,
    width: 2.94964,
    height: 16.2521,
    rx: 1,
    transform: "rotate(-45 16.8206 15.9062)",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1159_4915"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 33,
    fill: "white"
  })))));
}
export default SvgSoldPrice;